import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  JiraAssignableUserDto,
  JiraFieldDto,
  JiraFieldOptionDto,
  JiraIssueTypeDto,
  JiraProjectDto,
} from '@kortxio/hub-api';
import { reportApiError } from 'features/shared/reportApiError';
import api from 'libs/api';
import { AsyncThunkConfig } from 'store/types';

export const getJiraProjects = createAsyncThunk<
  JiraProjectDto[],
  void,
  AsyncThunkConfig
>(
  'monitoringJira/getJiraProjects',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.jira.getJiraProjects();

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);

export const getJiraIssueTypes = createAsyncThunk<
  JiraIssueTypeDto[],
  { projectId: string },
  AsyncThunkConfig
>(
  'monitoringJira/getJiraIssueTypes',
  async ({ projectId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.jira.getIssueTypesByProjectId(projectId);

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);

export const getJiraFields = createAsyncThunk<
  JiraFieldDto[],
  { projectId: string; issueTypeId: string },
  AsyncThunkConfig
>(
  'monitoringJira/getJiraFields',
  async ({ projectId, issueTypeId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.jira.getJiraFields(projectId, issueTypeId);

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);

export const getJiraAssignableUsers = createAsyncThunk<
  JiraAssignableUserDto[],
  { projectId: string; query: string },
  AsyncThunkConfig
>(
  'monitoringJira/getJiraAssignableUsers',
  async ({ projectId, query }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.jira.getJiraAssignableUsers(projectId, query);

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);

export const getJiraFieldOptions = createAsyncThunk<
  JiraFieldOptionDto[],
  { projectId: string; issueTypeId: string; fieldId: string },
  AsyncThunkConfig
>(
  'monitoringJira/getJiraFieldOptions',
  async (
    { projectId, issueTypeId, fieldId },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await api.jira.getJiraFieldOptions(
        projectId,
        issueTypeId,
        fieldId
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);

export const getJiraIssueOptions = createAsyncThunk<
  JiraFieldOptionDto[],
  { projectId: string; query: string },
  AsyncThunkConfig
>(
  'monitoringJira/getJiraIssueOptions',
  async ({ projectId, query }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.jira.getJiraIssueOptions(projectId, query);

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);
